import {Injectable} from "@angular/core";
import {User, Maestro, Tabla} from '../models/login/index';
//import { CryptoVar } from './cryptovar.service';
import {Router} from "@angular/router";
import {MessageService} from "primeng/api";
import {INavData} from "@coreui/angular";
@Injectable()
export class AuthService {
	public token: string;
	private usuario: string;
	//private password: string;
	// private savepass: boolean;
	public gotologin: boolean;
	private userJson: User;
	//  private roles:MaestroMin[];
	public tablas: Tabla[];
	// private clientes:MaestroMin[];
	// private productos:MaestroMin[];

	constructor(private messageService: MessageService, public router: Router) {
		//
		this.token = localStorage.getItem("token");
		this.gotologin = false;
		this.tablas = JSON.parse(localStorage.getItem("tablas"));
		if (this.tablas) this.tablas = [];
	}

	// public setToken(token){
	//     this.token=token;
	//     localStorage.setItem("token", this.token);
	// }
	// public getUrlApi(){
	//     return this.appConfig.apiUrl;
	// }
	// public getHeader(){
	//     var httpOptions:Object;
	//    return httpOptions = {
	//         headers: new HttpHeaders({
	//           'Content-Type':  'application/json' ,'Authorization': 'bearer '+ this.token
	//         })
	//       };
	// }
	// public getToken():string{
	//     if(this.token=="")
	//     {
	//        return  this.token=localStorage.getItem("token");
	//     }
	//     return this.token;
	// }
	public getusuarioJson(): User {
		if (this.userJson == null) {
			return (this.userJson = JSON.parse(localStorage.getItem("user"))); //new CryptoVar(this.appConfig).desencriptar(localStorage.getItem("userjson")));
		}
		return this.userJson;
	}
	public getlogin(): boolean {
		if (!this.gotologin) {
			if (localStorage.getItem("islogin") == "true") return true;
			return false;
		}
		return this.gotologin;
	}
	public isLogin(): boolean {
		if (!this.gotologin) {
			if (this.getlogin()) {
				return true;
			} else return false;
		}
		return true;
	}

	/*
    public reloadtoken(){      
        return this.Auth.Token(new MaestroMin(this.getusuario(),this.getpasword(),""))                     
    }    

    public reloadUser(){      
        return this.Auth.Login(new MaestroMin(this.getusuario(),this.getpasword(),""))                     
    }

    reloadAcceso(callback:Function,vm,params:object){
        if(this.getsave()){
            console.log("recargardo token");
            this.reloadtoken().subscribe(token => {
            this.setToken(token);        
            vm.recallCount++;
            if(vm.recallCount<3){          
              callback(vm,params);
            }
            else {
              this.addsmsWarn("No se puede recargar su acceso");  
              vm.recallCount=0;
            }            
          },error => { 
            this.addsmsError("Hubo un error recargando su acceso");
            vm.recallCount=0;
          });      
        }
        else {
            this.addsmsWarn("Su acceso expiro, Ingrese nuevamente");
          vm.router.navigate(['/Login'], { queryParams: { returnUrl:  vm.router.url }});
        }
      }*/
	/////////////////sms toas Alert show

	ErrorServer() {
		this.messageService.add({
			severity: "error",
			summary: "Error",
			detail: "Hubo un error conectandose al servidor"
		});
	}
	addsmsError(sms: string) {
		this.messageService.add({severity: "error", summary: "Error", detail: sms});
	}
	addsmsWarn(sms: string) {
		this.messageService.add({severity: "warn", summary: "Advertencia", detail: sms});
	}
	addsmsSuccess(sms: string) {
		this.messageService.add({severity: "success", summary: "Operacion Exitosa", detail: sms});
	}

	public setData(user: User) {
		//this.savepass=save;
		this.token = user.token;
		//this.password=user.Estado;
		this.usuario = user.usuario;
		user.token = "";
		localStorage.setItem("menu", JSON.stringify(user.barMenu));
		user.barMenu = [];
		//user.Estado=user.Password="";
		//localStorage.setItem("usuario", this.usuario);
		localStorage.setItem("token", this.token);
		localStorage.setItem("islogin", "true");
		localStorage.setItem("user", JSON.stringify(user)); //new CryptoVar(this.appConfig).encriptar(JSON.stringify(user)));
		// if(save)
		//     {
		//         localStorage.setItem("password", new CryptoVar(this.appConfig).encriptar(this.password));
		//         localStorage.setItem("usuario",this.usuario);
		//     }
		this.userJson = user;
		this.gotologin = true;
	}

	logout() {
		localStorage.clear();
		this.router.navigate(["/login"]);
	}

	has_access_to(value: string): boolean {
		var urls = value.split("/");
		var returnval = 1;
		this.getAccesosUser().forEach((element) => {
			if (value.indexOf(element.url.toString()) > -1) {
				returnval++;
				if (element.children.length > 0) {
					returnval += this.geturlcount(element, value);
				}
			}
		});
		if (returnval >= urls.length) return true;
		return false;
	}

	geturlcount(itemlist: INavData, value: string): number {
		var returnval = 0;
		itemlist.children.forEach((item) => {
			if (value.indexOf(item.url.toString()) > -1) returnval++;
		});
		return returnval;
	}

	getTabla(codTabla: string): Maestro[] {
		// console.log(localStorage.getItem("tablas"));
		if (this.tablas.length === 0) {
			this.tablas = JSON.parse(localStorage.getItem("tablas"));
		}
		return this.tablas.filter((t) => t.codTabla === codTabla)[0].tipos;
	}
	getDescripcion(codTabla: string, codRegistro: string): string {
		if (this.tablas.length === 0) {
			this.tablas = JSON.parse(localStorage.getItem("tablas"));
		}
		return (
			this.tablas
				.filter((t) => t.codTabla === codTabla)[0]
				.tipos.filter((r) => r.codRegistro == codRegistro)[0].descripcion || null
		);
	}
	setMaestros(tablas: Tabla[]) {
		this.tablas = tablas;
		localStorage.setItem("tablas", JSON.stringify(tablas));
	}
	public getAccesosUser(): INavData[] {
		if (this.userJson == null) {
			return (this.userJson.barMenu = JSON.parse(localStorage.getItem("menu")));
		}
		return this.userJson.barMenu;
	}

	// getRoles():MaestroMin[]{
	//     if(this.roles == null){
	//        return this.roles=JSON.parse(localStorage.getItem("roles"))
	//     }
	//     else return this.roles
	// }

	// setRoles(roles:MaestroMin[]){
	//     this.roles=roles;
	//     localStorage.setItem("roles",JSON.stringify(roles));
	// }

	// public isSuperAdmin():boolean{
	//     return this.getusuarioJson().Roles.indexOf("1:SuperAdministrador")>=0
	// }

	// public getusuario():string{
	//     if(this.usuario=="")
	//     {
	//        return  this.usuario=localStorage.getItem("usuario");
	//     }
	//     return this.usuario;
	// }

	// public getpasword(){
	//     if(this.password=="")
	//     {
	//        return  this.password="";//new CryptoVar(this.appConfig).desencriptar(localStorage.getItem("password"));
	//     }
	//     return this.password;
	// }
	// getClientes():MaestroMin[]{
	//     if(this.clientes == null){
	//        return this.clientes=JSON.parse(localStorage.getItem("clientes"))
	//     }
	//     else return this.clientes
	// }

	// setClientes(clientes:MaestroMin[]){
	//     this.clientes=clientes;
	//     localStorage.setItem("clientes",JSON.stringify(clientes));
	// }

	// getProductos():MaestroMin[]{
	//     if(this.productos == null){
	//        return this.productos=JSON.parse(localStorage.getItem("productos"))
	//     }
	//     else return this.productos
	// }

	// setProductos(productos:MaestroMin[]){
	//     this.productos=productos;
	//     localStorage.setItem("productos",JSON.stringify(productos));
	// }
}
